import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  p {
    margin: 0;
  }
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;
export const HeaderTitle = styled.p`
  font-size: 30px;
  font-weight: 600;
  color: #1c1b3a;
`;
export const HeaderItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
export const HeaderItemRight = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 30px;
  min-height: 800px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    row-gap: 50px;
  }
`;
export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  row-gap: 20px;
  flex-grow: 1;
  margin: 20px 10px 10px 10px;
  overflow-y: scroll;
  max-height: 800px;
  &::-webkit-scrollbar {
    width: 10px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
export const ScrollableContainerEmpty = styled(ScrollableContainer)`
  justify-content: center;
`;
